import React, { useMemo } from 'react';
import CruiseCard from './CruiseCard';
import { getMMT_HLD_OBJ } from '../common/utils/appUtils';
import AboutPackages from '../listingV3/App/Listing/ListingBody/ListingRHS/PackageDetails/AboutPackages';

const getTypeDest = () => {
  const currentUrl = ssr.isOnClient ? window.location.href : null;
  const parts = currentUrl?.split('/holidays-');
  const holidayParts = parts?.[1]?.split('/');
  const typeDestination = holidayParts?.[0];
  return typeDestination;
};
const Cruise = () => {
  const typeDest = useMemo(() => getTypeDest(), [ssr.isOnClient]);

  const { fromSEO } = getMMT_HLD_OBJ();
  return (
    <>
      {/* {fromSEO && <AboutPackages />} */}

      <CruiseCard typeDestination={typeDest} />
    </>
  );
};

export default Cruise;
